/* PrismTide product-only interaction helpers. Native Shopify media/cart logic remains authoritative. */
(() => {
  const bindMainGalleryFallback = (gallery) => {
    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    const list = viewer?.querySelector(':scope > .product__media-list');
    const controls = viewer?.querySelector(':scope > .slider-buttons');
    const previous = controls?.querySelector('button[name="previous"]');
    const next = controls?.querySelector('button[name="next"]');

    if (!viewer || !list || !previous || !next || viewer.dataset.prismtideMainNavBound === 'true') return;
    viewer.dataset.prismtideMainNavBound = 'true';

    const getItems = () => Array.from(list.querySelectorAll(':scope > [data-media-id]'));

    const fallbackMode = () =>
      window.matchMedia('(min-width: 750px)').matches &&
      getItems().filter((item) => item.getClientRects().length > 0).length <= 1;

    const activeState = () => {
      const items = getItems();
      const active = items.findIndex((item) => item.classList.contains('is-active'));
      return { items, index: active < 0 ? 0 : active };
    };

    const sync = () => {
      const { items, index } = activeState();
      const current = controls.querySelector('.slider-counter--current');
      const total = controls.querySelector('.slider-counter--total');

      if (current) current.textContent = String(index + 1);
      if (total) total.textContent = String(items.length);

      if (fallbackMode()) {
        previous.disabled = index <= 0;
        next.disabled = index >= items.length - 1;
      }
    };

    const move = (direction) => (event) => {
      if (!fallbackMode()) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const { items, index } = activeState();
      const targetIndex = Math.max(0, Math.min(items.length - 1, index + direction));
      if (targetIndex === index) return;

      const mediaId = items[targetIndex]?.dataset.mediaId;
      if (mediaId && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
        requestAnimationFrame(sync);
      }
    };

    previous.addEventListener('click', move(-1), { capture: true });
    next.addEventListener('click', move(1), { capture: true });

    const observer = new MutationObserver(() => requestAnimationFrame(sync));
    observer.observe(list, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    const mediaQuery = window.matchMedia('(min-width: 750px)');
    const handleModeChange = () => {
      if (fallbackMode()) {
        sync();
      } else if (typeof viewer.resetPages === 'function') {
        viewer.resetPages();
      }
    };

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleModeChange);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(handleModeChange);
    }

    sync();
  };

  const init = (root) => {
    if (!root || root.dataset.prismtideEnhanced === 'true') return;
    root.dataset.prismtideEnhanced = 'true';

    const sectionId = root.dataset.section;
    const variantsNode = document.getElementById(`PrismTideVariants-${sectionId}`);
    const selectedNode = document.getElementById(`PrismTideSelectedVariant-${sectionId}`);

    // If a stale/deep-linked variant is unavailable but another variant is genuinely purchasable,
    // reload onto Shopify's first available variant. Never falsify availability when all variants are unavailable.
    try {
      const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
      const selected = selectedNode ? JSON.parse(selectedNode.textContent) : null;
      if (selected && selected.available === false) {
        const firstAvailable = variants.find((variant) => variant && variant.available);
        if (firstAvailable && String(firstAvailable.id) !== String(selected.id)) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', firstAvailable.id);
          window.location.replace(url.toString());
          return;
        }
      }
    } catch (error) {
      console.warn('PrismTide availability fallback skipped:', error);
    }

    const gallery = root.querySelector('media-gallery');
    if (gallery) bindMainGalleryFallback(gallery);

    if (gallery && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]').forEach((item) => {
        const button = item.querySelector('button');
        if (!button || button.dataset.prismtideHoverBound === 'true') return;
        button.dataset.prismtideHoverBound = 'true';
        button.addEventListener('mouseenter', () => {
          if (typeof gallery.setActiveMedia === 'function') {
            gallery.setActiveMedia(item.dataset.target, false);
          }
        });
      });
    }
  };

  const initAll = () => document.querySelectorAll('product-info.prismtide-page').forEach(init);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('product-info:loaded', (event) => {
    const root = event.target?.matches?.('product-info.prismtide-page') ? event.target : null;
    if (root) init(root);
  });
  initAll();
})();
